import script from "./TemplateEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&setup=true&lang=js"

import "./TemplateEditor.vue?vue&type=style&index=0&id=4ae6d6fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae6d6fe"]])

export default __exports__